import React from 'react';

export function CadastroInstituicao({ modalData }) {
  return (
    <div>
      <div>
        <span>CNES</span>
        <p>{modalData && modalData.cnes}</p>
      </div>

      <div>
        <span>Instituição</span>
        <p>{modalData && modalData.nomeFantasia}</p>
      </div>

      <div>
        <span>Cidade</span>
        <p>{modalData && modalData.cidade}</p>
      </div>

      <div>
        <span>Estado</span>
        <p>{modalData && modalData.estado}</p>
      </div>

      <div>
        <span>CNPJ</span>
        <p>{modalData && modalData.cnpj}</p>
      </div>

      <div>
        <span>Telefone</span>
        <p>{modalData && modalData.telefone}</p>
      </div>

      <div>
        <span>Situação</span>
        <p>{modalData && modalData.ativo ? 'Ativa' : 'Inativa'}</p>
      </div>

      <div>
        <span>Endereço</span>
        <p>{modalData && modalData.address}</p>
      </div>

      <div>
        <span>CEP</span>
        <p>{modalData && modalData.cep}</p>
      </div>

      <div>
        <span>Número</span>
        <p>{modalData && modalData.numero}</p>
      </div>

      <div>
        <span>Responsável</span>
        <p>{modalData && modalDataResponsavel.nomeUsuario}</p>
      </div>

      <div>
        <span>E-mail</span>
        <p>{modalData && modalDataResponsavel.email}</p>
      </div>
    </div>
  );
}
